import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=23de0068&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"
import style0 from "./Access.vue?vue&type=style&index=0&id=23de0068&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de0068",
  null
  
)

export default component.exports